import type { Tasting } from '../../types'
import { calculateResults, indexToLetter } from '../../utils/scoring'

type WineRankingChartProps = {
  tasting: Tasting
}

export function WineRankingChart({ tasting }: WineRankingChartProps) {
  const results = calculateResults(tasting)

  const maxPoints = Math.max(...results.map((r) => r.totalPoints))
  const barMaxHeight = 160 // pixels

  return (
    <div className="flex items-end justify-center gap-2">
      {results.map((wine) => {
        const barHeight = Math.max(8, (wine.totalPoints / maxPoints) * barMaxHeight)

        return (
          <div key={wine.index} className="flex flex-col items-center gap-1">
            <div
              className="w-10 sm:w-12 bg-purple-500 rounded-t transition-all duration-300 flex items-end justify-center"
              style={{ height: `${barHeight}px` }}
              title={`${wine.name ?? 'Unassigned'}: ${wine.totalPoints} points (Rank #${wine.rank})`}
            >
              <span className="text-white text-xs font-medium pb-1">
                {wine.totalPoints}
              </span>
            </div>
            <span className="text-sm font-medium">{indexToLetter(wine.index)}</span>
            <span className="text-xs text-gray-500">#{wine.rank}</span>
          </div>
        )
      })}
    </div>
  )
}
